// Identidade visual da empresa responsável pelo LOOTUS — FRONTEND ONLY
// (pacote de melhorias, item 5/9). LOOTUS continua sendo o nome do
// PRODUTO; estas constantes são só da EMPRESA responsável por ele,
// exibida em rodapés/telas institucionais. Nunca altera nada no
// backend/banco/coleções/nomes técnicos — ver docs/relatório do pacote.
export const PRODUCT_NAME = "LOOTUS";
export const PLATFORM_COMPANY_NAME = "Codexpy Software Ltda.";
export const PLATFORM_COMPANY_SHORT_NAME = "Codexpy";
